import { render, staticRenderFns } from "./metrics_empty_page.vue?vue&type=template&id=ee8358a8&scoped=true&"
import script from "./metrics_empty_page.vue?vue&type=script&lang=js&"
export * from "./metrics_empty_page.vue?vue&type=script&lang=js&"
import style0 from "./metrics_empty_page.vue?vue&type=style&index=0&id=ee8358a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8358a8",
  null
  
)

export default component.exports